
import { getCommonHead } from "@/utils/head"
import bottom from "@/components/bottom"
export default {
  components: {
    bottom
  },
  head() {
    return getCommonHead()
  }
}
